/**
 * THE SITE'S PUBLIC PLACES, GROUPED (Miles, 2026-10-07: "find the subfolders and link them in drop down like a large
 * sophisticated company would to appeal to different audiences and help users navigate the web application much much
 * easier across the web application").
 *
 * One list, read by the new design's header (its menus and the phone's sheet), the new design's footer and today's
 * footer (src/components/GlobalFooter.tsx), so the three never offer different places. Plain data with no React and no
 * styles: today's footer rides the first download, the new design's header rides the shell's chunk, and both import it.
 *
 * Every `to` is a route App.tsx declares (tests/landing/siteNavigation.test.ts reads the routes from App.tsx). What each
 * place is about, a line under its name in the header's menus, lives in ./siteNavigationDescriptions.ts, which only the
 * menus' own chunk imports.
 */
export type SiteNavGroupId = 'solutions' | 'product' | 'company';

export interface SiteNavItem {
  to: string;
  label: string;
}

export interface SiteNavGroup {
  id: SiteNavGroupId;
  label: string;
  items: readonly SiteNavItem[];
}

export const SITE_NAV_GROUPS: readonly SiteNavGroup[] = [
  {
    id: 'solutions',
    label: 'solutions',
    items: [
      { to: '/for-lawyers', label: 'for law firms' },
      { to: '/for-enterprise', label: 'for enterprise' },
      { to: '/for-individuals', label: 'for individuals' },
    ],
  },
  {
    id: 'product',
    label: 'product',
    items: [
      { to: '/#features', label: 'features' },
      { to: '/security', label: 'security' },
      { to: '/trust', label: 'trust center' },
    ],
  },
  {
    id: 'company',
    label: 'company',
    items: [
      { to: '/about', label: 'about' },
      { to: '/team', label: 'team' },
      { to: '/mission', label: 'mission' },
      { to: '/insights', label: 'insights' },
    ],
  },
];

/** The one place the header links to directly, after the groups. */
export const SITE_NAV_PRICING: SiteNavItem = { to: '/pricing', label: 'pricing' };

/** Is `to` the page at `pathname`? A link to a section of the home page (`/#features`) is never "the page". */
export function isSiteNavCurrent(to: string, pathname: string): boolean {
  if (to.includes('#')) return false;
  return pathname === to;
}
